<template>
    <div class="ui-page">
        <ui-page-header title="Administradores" subtitle="Usuários administradores do backoffice e seus perfis de acesso.">
            <v-btn v-if="$allowed('create')" id="btnNew" type="button" color="primary" depressed to="/admins/novo">
                <v-icon left small>mdi-plus</v-icon>
                Incluir
            </v-btn>
        </ui-page-header>

        <ui-table-card clearable :can-clear="hasFilters" @clear="clearFilters">
            <template #toolbar>
                <v-text-field dense id="name" placeholder="Buscar pelo nome" v-model="dataList.filter.name" prepend-inner-icon="mdi-magnify"
                    hide-details outlined class="ui-toolbar__search" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
                <v-text-field dense id="email" placeholder="E-mail" v-model="dataList.filter.email"
                    hide-details outlined class="ui-toolbar__field" @input="filterDebounced" @keyup.enter="applyFilters"></v-text-field>
                <v-select dense id="profile" :items="dataset.adminProfiles" placeholder="Todos os perfis"
                    v-model="dataList.filter.profile" item-value="id" item-text="name" outlined hide-details
                    class="ui-toolbar__field" :menu-props="{ offsetY: true }" @change="applyFilters">
                </v-select>
            </template>

            <v-data-table :headers="dataList.headers" :items="dataList.data"
                :server-items-length="dataList.count" disable-sort hide-default-footer :loading="dataList.loading"
                no-data-text="Nenhum administrador foi encontrado" loading-text="Carregando dados..."
                :options.sync="dataList.options" class="ui-clickable-rows" @click:row="viewItem">
                <template v-slot:[`item.name`]="{ item }">
                    <div class="ui-cell-main">{{ item.name }}</div>
                    <div class="ui-cell-sub">{{ item.email }}</div>
                </template>

                <template v-slot:[`item.profile`]="{ item }">
                    <ui-badge :text="item.profile | enum(dataset.adminProfiles, 'id', 'name')" tone="primary" />
                </template>

                <template v-slot:[`item.vehicles`]="{ item }">
                    <span>{{ item.vehicles ? item.vehicle.length : 0 }}</span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <ui-row-actions :actions="[
                        { text: 'Editar', icon: 'mdi-pencil-outline', handler: () => viewItem(item) , disabled: !$allowed('edit') },
                        { text: 'Excluir', icon: 'mdi-delete-outline', danger: true, handler: () => remove(item) , disabled: !$allowed('delete') },
                    ]" />
                </template>
            </v-data-table>

            <template #footer>
                <ui-pagination :total="dataList.count" :page="dataList.options.page" :items-per-page="dataList.options.size"
                    :disabled="dataList.loading" @update:page="pageChanged" @update:itemsPerPage="setPageSize" />
            </template>
        </ui-table-card>
    </div>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"


Vue.use(VueLodash)

export default {
    name: "ClientList",

    data: () => ({
        dataset: {
            adminProfiles: [{id:"", name: "Todos"}]
        },
        dataList: {
            filter: {
                name: "",
                email: "",
                profile: 0,
            },
            headers: [
                { text: "Nome", value: "name" },
                { text: "Perfil", value: "profile" },
                { text: '', value: 'actions', sortable: false, align: 'end', width: 56 },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
    }),

    computed: {
        hasFilters() {
            return Object.values(this.dataList.filter).some((value) => value);
        },
    },

    created() {

        if(!this.$check('Admin', 'GET')) this.$router.push(`home`);

        this.loadProfiles();
        this.load();
    },

    methods: {
        // Perfis de acesso cadastrados (Administracao > Perfis).
        async loadProfiles() {
            try {
                const result = await axios.get("/api/admin/profiles");
                this.dataset.adminProfiles = [{ id: "", name: "Todos" }, ...result.data.content];
            } catch (error) {
                // O filtro fica so com "Todos"; a lista carrega igual.
            }
        },

        applyFilters() {
            this.dataList.options.page = 1;
            this.load();
        },

        filterDebounced: _.debounce(function () {
            this.applyFilters();
        }, 400),

        clearFilters() {
            this.dataList.filter = { name: "", email: "", profile: 0 };
            this.applyFilters();
        },

        // A troca de tamanho e seguida de update:page(1), que recarrega.
        setPageSize(size) {
            this.dataList.options.size = size;
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),
        reload: function () {
            this.load();
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.size;
            var start = (this.dataList.options.page - 1) * limit;

            try {
                const result = await axios.get('/api/admin/list', { params: { start: start, limit: limit, search: search } });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async remove(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir admin',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`/api/admin/delete/${item.id}`)

                this.$dialog.notify.info("Admin excluído com sucesso", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`admins/${item.id}`);
        },
    },
};
</script>
